import React, { Fragment, memo, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { getMessage } from 'util/locale';
import { getCurrency } from 'user/userSelectors';
import { MULTIPLE_AGRONOMIC_SEASONS_COUNTRIES } from 'constants/advanced';
import { FieldData } from '../../common/types';
import GrainPriceInput from './GrainPriceInput';
import PlantingDateInput from './PlantingDateInput';
import FieldsTable from './FieldsTable';
import SeasonInput from './SeasonInput';

const baseString = 'script-generation';

interface ScriptGenerationProps {
  multipleHybrids?: boolean;
  excludedBrandUuids?: string[];
}

export const ScriptGeneration = memo(
  function ScriptGeneration({ multipleHybrids, excludedBrandUuids }: ScriptGenerationProps) {
    const currency = useSelector(getCurrency);
    const [isMultipleAgronomicSeasons, setIsMultipleAgronomicSeasons] = useState(false);

    const onFieldsLoad = useCallback((fields: FieldData[]) => {
      if (fields.some((field) =>
        MULTIPLE_AGRONOMIC_SEASONS_COUNTRIES.includes(field.countryCode)
      )) {
        setIsMultipleAgronomicSeasons(true);
      }
    }, []);

    return (
      <Fragment>
        <div className={`${baseString}-global-inputs`}>
          <div>
            <p>
              1.{' '}
              {getMessage(
                'bulk-fvss-script-generation-planned-planting-date-step'
              )}
            </p>
            <PlantingDateInput />
          </div>
          <div>
            <p>2. {getMessage('bulk-fvss-review-scripts-grain-price-title')}</p>
            <GrainPriceInput currency={currency} />
          </div>
          {isMultipleAgronomicSeasons && (
            <div>
              <p>3. {getMessage('bulk-fvss-review-scripts-season-title')}</p>
              <SeasonInput />
            </div>
          )}
        </div>
        <div className={`${baseString}-field-selection-table`}>
          <p>
            {isMultipleAgronomicSeasons ? '4.' : '3.'}{' '}
            {getMessage('bulk-fvss-script-generation-planting-details-step')}
          </p>
          <FieldsTable
            currency={currency}
            multipleHybrids={multipleHybrids}
            onFieldsLoad={onFieldsLoad}
            excludedBrandUuids={excludedBrandUuids}
          />
        </div>
      </Fragment>
    );
  }
);
